import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
//import CardHeader from '@material-ui/core/CardHeader';
import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';

import * as d3 from 'd3';

const styles = theme => ({
  card: {
    display: 'flex column',
    margin: 0,
    borderColor: 'rgba(255,255,255,0)!important',
    boxShadow: '0px 0px 0px 0px rgba(255,255,255,0)!important',
    backgroundColor: '#f3f3f3',
  },
  cardHeader: {
    //backgroundColor: '#165469',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    padding: '5px',
    paddingLeft: '20px',
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    fontSize: '1.1em',
    fontWeight: 700,
    borderRadius: '10px',
  },
  imageBlock: {
    display: 'block',
    margin: '0 auto',
    textIndent: '-9999px',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  solarOn: {
    background: 'url("/images/vea_selected_energy/solar_white.svg")',
  },
  solarOff: {
    background: 'url("/images/vea_selected_energy/solar_transp_blue.svg")',
  },
  onshoreWindOn: {
    background: 'url("/images/vea_selected_energy/onshoreWind_white.svg")',
  },
  onshoreWindOff: {
    background: 'url("/images/vea_selected_energy/onshoreWind_transp_blue.svg")',
  },
  offshoreWindOn: {
    background: 'url("/images/vea_selected_energy/offshoreWind_white.svg")',
  },
  offshoreWindOff: {
    background: 'url("/images/vea_selected_energy/offshoreWind_transp_blue.svg")',
  },
  cardContent: {
    padding: '0!important',
    marginTop: '10px;',
    height: '80px',
  },
  statValue: {
    //fontSize: '1em',
    marginRight: '2px',
    fontFamily: 'Flanders Art Sans!important',
  },
});

function DayTopIndicatorCard(props) {
  const { classes } = props;
  /*
  let locale = d3.timeFormatDefaultLocale({
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["€", ""],
    "dateTime": "%a %b %e %X %Y",
    "date": "%d.%m.%Y",
    "time": "%H:%M:%S",
    "periods": ["AM", "PM"],
    "days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
    "shortDays": ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    "months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
    "shortMonths": ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
  })

  let cardHeaderTitle

  switch (props.lang) {
    case "de":
      cardHeaderTitle = "Énergie  en Wallonie aujourd'hui"
      break
    case "en":
      cardHeaderTitle = "Energy in Wallonie today"
      break
    case "fr":
      cardHeaderTitle = "Énergie  en Wallonie aujourd'hui"
      break
    case "nl":
    default:
      cardHeaderTitle = "Productie in Vlaanderen"
  }
*/
  let statData = props.statisticsData
  let topIndicators = statData ? (
    <Grid container spacing={2}  className={" darkbluegreen"} style={{textAlign:'left',paddingLeft:'10px',fontweight:600}}>
      <Grid item xs={12} style={{textAlign:'left',paddingTop:'4px',paddingBottom:'0px',paddingLeft:'5px'}}>
        <span className={classes.statValue}>
          {statData['energy_sum'].value.toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + (statData['energy_sum'].unit ? (statData['energy_sum'].unit === '%' ? statData['energy_sum'].unit : '') : '')}
        </span>
        <span >
          {(statData['energy_sum'].unit ? (statData['energy_sum'].unit === '%' ? '' : (' ' + statData['energy_sum'].unit)) : '') + ' ' + statData['energy_sum'].label}
        </span>
      </Grid>
      <Grid item xs={12} style={{textAlign:'left',paddingTop:'4px',paddingBottom:'0px',paddingLeft:'5px'}}>
        <span className={classes.statValue}>
          {statData['energy_as_percentage_of_demand'].value.toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + (statData['energy_as_percentage_of_demand'].unit ? (statData['energy_as_percentage_of_demand'].unit === '%' ? statData['energy_as_percentage_of_demand'].unit : '') : '')}
        </span>
        <span >
          {(statData['energy_as_percentage_of_demand'].unit ? (statData['energy_as_percentage_of_demand'].unit === '%' ? '' : (' ' + statData['energy_as_percentage_of_demand'].unit)) : '') + ' ' + statData['energy_as_percentage_of_demand'].label}
        </span>
      </Grid>
    </Grid>
  ) : null
  return (
    <Card className={classes.card}>
      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        <div style={{ height: '40px', lineHeight: "40px" }}>{props.currentMode === 'realtime'?(d3.timeFormat('%e %B')(props.selectedDate)):props.selectedYear}</div>
        <div style={{display:"flex"}}>
          <div className={classes.imageBlock + " " + classes[(props.currentTech.solar ? 'solarOn' : 'solarOff')]}></div>
          <div className={classes.imageBlock + " " + classes[(props.currentTech.wind ? 'onshoreWindOn' : 'onshoreWindOff')]}></div>        
          <div className={classes.imageBlock + " " + classes[(props.currentTech.windOffshore ? 'offshoreWindOn' : 'offshoreWindOff')]}></div>
        </div>
      </Paper>

      <CardContent className={classes.cardContent}>
        {
          topIndicators
        }

      </CardContent>
    </Card>
  );
}

DayTopIndicatorCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DayTopIndicatorCard);
